import axios from 'axios'

// Výchozí nastavení
//var ServiceBaseURL = 'http://gp.nli.gov.cz/ds_lhotest/ws.lhpoM/serviceLhpom.svc';
var ServiceBaseURL = '';
var ServiceWithCredentials = true; // true - za eagri, jinak false
var ServiceHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};

var apiClient
/* var apiClient = axios.create({
    baseURL: ServiceBaseURL,
    withCredentials: ServiceWithCredentials,
    headers: ServiceHeaders
}) */

export default {

    // Inicializace
    Init(url) {
        ServiceBaseURL = url;
        apiClient = axios.create({
            baseURL: ServiceBaseURL,
            withCredentials: ServiceWithCredentials,
            headers: ServiceHeaders
        })
    },

    // Seznam Ds
    SeznamDs() {
        return apiClient.get(`/SeznamDs`)
    },

    // DS

    // Seznam Lhc
    DsSeznamLhc(Jid) {
        return apiClient.get(`/DsSeznamLhc`, {
            params: {
                Jid: Jid
            }
        })
    },

    // Seznam číselníků
    DsSeznamCis(Jid) {
        return apiClient.get(`/DsSeznamCis`, {
            params: {
                Jid: Jid,
            }
        })
    },

    // Číselník
    DsCis(Jid, CisJmeno, Rocnik) {
        return apiClient.get(`/DsCis`, {
            params: {
                Jid: Jid,
                CisJmeno: CisJmeno,
                Rocnik: Rocnik,
            }
        })
    },


    // LHC

    // Základní Info 
    LhcInfoBasic(Jid, MajKod) {
        return apiClient.get(`/LhcInfoBasic`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
            }
        })
    },

    // Stav vybraného Lhc
    // LhcStav 1 - SouvisleZobrazeni
    // LhcStav 2 - SchvalenyStav
    LhcInfoStav(Jid, LhcStav) {
        return apiClient.get(`/LhcInfoStav`, {
            params: {
                Jid: Jid,
                LhcStav: LhcStav,
            }
        })
    },

    // Seznam Jprl vybraného Lhc
    LhcSeznamJprl(Jid, MajKod) {
        return apiClient.get(`/LhcSeznamJprl`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
            }
        })
    },

    // Seznam majetků vybraného Lhc
    LhcSeznamMaj(Jid) {
        return apiClient.get(`/LhcSeznamMaj`, {
            params: {
                Jid: Jid,
            }
        })
    },

    // Seznam PLO vybraného Lhc
    LhcSeznamPlo(Jid, MajKod) {
        return apiClient.get(`/LhcSeznamPlo`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
            }
        })
    },

    // Seznam ORP vybraného Lhc
    LhcSeznamOrp(Jid, MajKod) {
        return apiClient.get(`/LhcSeznamOrp`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
            }
        })
    },

    // LHC - njemenší opsaný obdelník
    LhcMbr(Jid, MajKod, EpsgCode) {
        return apiClient.get(`/LhcMbr`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
                EpsgCode: EpsgCode,
            }
        })
    },

    // LHC - vyhláškové tabulkyZákladní Info 
    LhcTab(Jid, MajKod, Tab) {
        return apiClient.get(`/LhcTab`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
                Tab: Tab,
            }
        })
    },

    // LHC - výpisy
    LhcJprlVypis(Jid, JidJprl) {
        return apiClient.get(`/LhcJprlVypis`, {
            params: {
                Jid: Jid,
                JidJprl: JidJprl,

            }
        })
    },



    // JPRL


    // Výpis z knihy - jprl
    JprlVypis(Jid) {
        return apiClient.get(`/JprlVypis`, {
            params: {
                Jid: Jid,
            }
        })
    },

    // Opsaný obdelník - jprl
    JprlMbr(Jid) {
        return apiClient.get(`/JprlMbr`, {
            params: {
                Jid: Jid,
            }
        })
    },


    // BBOX

    // Seznam jprl podle obdelníku
    BboxJprl(Jid, EpsgCode, Xmin, Ymin, Xmax, Ymax, SchvStav, Vypis) {
        return apiClient.get(`/BboxJprl`, {
            params: {
                Jid: Jid,
                EpsgCode: EpsgCode,
                Xmin: Xmin,
                Ymin: Ymin,
                Xmax: Xmax,
                Ymax: Ymax,
                SchvStav: SchvStav,
                Vypis: Vypis,
            }
        })
    },

    // Seznam jprl podle obdelníku plus Majkod
    BboxJprlMaj(Jid, MajKod, EpsgCode, Xmin, Ymin, Xmax, Ymax, SchvStav, Vypis) {
        return apiClient.get(`/BboxJprlMaj`, {
            params: {
                Jid: Jid,
                MajKod: MajKod,
                EpsgCode: EpsgCode,
                Xmin: Xmin,
                Ymin: Ymin,
                Xmax: Xmax,
                Ymax: Ymax,
                SchvStav: SchvStav,
                Vypis: Vypis,
            }
        })
    },




}